import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { PubMainTypeEnum, PubSuffixTypeEnum, SourceType } from '../types';
function getIntialPubtypeState(source) {
  switch (source) {
    case SourceType.DIGITAL_FILE:
    case SourceType.MISCELLANEOUS:
    case SourceType.EMAIL:
    case SourceType.RAW_DATA:
      return {
        main: PubMainTypeEnum.PUB_OTHER,
        suffix: PubSuffixTypeEnum.PUB_NONE
      };
    case SourceType.ONLINE_DATABASE:
      return {
        main: PubMainTypeEnum.PUB_DATABASE,
        suffix: PubSuffixTypeEnum.PUB_NONE
      };
    case SourceType.EXECUTIVE_ORDER:
    case SourceType.FEDERAL_REPORT:
    case SourceType.FEDERAL_RULE:
    case SourceType.FEDERAL_TESTIMONY:
    case SourceType.FEDERAL_STATUTE:
      return {
        main: PubMainTypeEnum.PUB_FEDERAL,
        suffix: PubSuffixTypeEnum.PUB_NONE
      };
    case SourceType.PATENT:
      return {
        main: PubMainTypeEnum.PUB_NONE,
        suffix: PubSuffixTypeEnum.PUB_NONE
      };
    case SourceType.PAMPHLET:
      return {
        main: PubMainTypeEnum.PUB_NONPERIODICAL,
        suffix: PubSuffixTypeEnum.PUB_NONE
      };
    case SourceType.PERFORMANCE:
      return {
        main: PubMainTypeEnum.PUB_LIVE,
        suffix: PubSuffixTypeEnum.PUB_NONE
      };
    case SourceType.WEBSITE:
    case SourceType.DIGITAL_IMAGE:
    case SourceType.BLOG:
    case SourceType.SCHOLARLY_PROJECT:
    case SourceType.MAILING_LIST:
    case SourceType.NEWSGROUP:
    default:
      return {
        main: PubMainTypeEnum.PUB_ONLINE,
        suffix: PubSuffixTypeEnum.PUB_NONE
      };
  }
}
export var useWritingForm = function useWritingForm(source) {
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  useEffect(function () {
    if (!values['pubtype']) setFieldValue('pubtype', getIntialPubtypeState(source));
    if (!values['source']) setFieldValue('source', source);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};